import Typo from 'typo-js';

// Instantiate front end spell-checking tool
export default new Typo('en_US', false, false, {
  dictionaryPath: '/assets/dictionary',
});
